import React from 'react';
import { useI18n } from '../lib/i18n';
export function Footer() {
  const {
    t
  } = useI18n();
  return <footer className="w-full bg-[#05060A] border-t border-white/5 py-12 px-6 md:px-12" data-id="element-107">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-108">
        <div data-id="element-109">
          <div className="text-lg text-white font-light tracking-tight" data-id="element-110">
            CLVN–LRR™
          </div>
          <div className="text-xs text-white/40 mt-1" data-id="element-111">clvn-lrr.com</div>
        </div>
        <p className="text-xs font-mono text-white/40 tracking-wider" data-id="element-112">
          {t('footer.signature')}
        </p>
        <p className="text-xs text-white/30" data-id="element-113">© 2025 · {t('footer.rights')}</p>
      </div>
    </footer>;
}